export default __webpack_public_path__ + "static/media/robin_1.41896252.mp3";